(function () {
  'use strict';
  function sync(form, variantChanged) {
    var choices = form.querySelector('[data-be-card-purchase]');
    if (!choices) return;
    var variant = form.querySelector('[name="id"]');
    var type = choices.querySelector('[data-be-purchase-type]');
    var plan = choices.querySelector('[data-be-selling-plan]');
    var template = Array.from(choices.querySelectorAll('template[data-be-plan-variant]')).find(function (item) { return item.dataset.bePlanVariant === variant.value; });
    if (variantChanged || choices.dataset.variant !== variant.value) {
      var previous = plan.value;
      plan.replaceChildren();
      if (template) plan.appendChild(template.content.cloneNode(true));
      if (Array.from(plan.options).some(function (option) { return option.value === previous; })) plan.value = previous;
      choices.dataset.variant = variant.value;
    }
    var eligible = !!(template && plan.options.length);
    type.querySelector('[value="subscription"]').disabled = !eligible;
    if (!eligible) type.value = 'once';
    var subscribing = eligible && type.value === 'subscription';
    plan.disabled = !subscribing;
    choices.querySelector('[data-be-plan-label]').hidden = !subscribing;
    choices.querySelector('[data-be-purchase-terms]').hidden = !subscribing;
    var selected = plan.selectedOptions[0];
    choices.querySelector('[data-be-purchase-price]').textContent = subscribing ? selected.dataset.bePlanPrice + ' per delivery. ' + selected.textContent : (template ? template.dataset.beOncePrice + ' one time' : '');
    var button = form.querySelector('button[name="add"] span');
    if (button) button.textContent = subscribing ? 'Add subscription to cart' : 'Add one-time to cart';
  }
  function scan(root) {
    root.querySelectorAll('[data-be-card-purchase]').forEach(function (choices) { sync(choices.closest('form'), false); });
  }
  document.addEventListener('change', function (event) {
    var form = event.target.closest('.buy-product-container form');
    if (form && (event.target.matches('[name="id"]') || event.target.closest('[data-be-card-purchase]'))) sync(form, event.target.matches('[name="id"]'));
  });
  // Validate the allocation again immediately before other cart integrations serialize it.
  document.addEventListener('submit', function (event) {
    if (event.target.matches('.buy-product-container form')) sync(event.target, false);
  }, true);
  scan(document);
  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1 && !node.closest('[data-be-card-purchase]')) scan(node);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
